import initialState from './State';
import {
    SET_ACTIVE_SCREEN,
    SET_JOB,
    GET_JOB,
    SET_PHONE,
    GET_CARLIST,
    SET_PROFILE,
    SET_TOKEN,
    SET_FIREBASE_TOKEN,
    GET_FIREBASE_TOKEN,
    SET_ACTIVE_JOB,
    CREATE_ACCOUNT,
    SET_BIDS,
    SET_BID,
    SEND_OTP,
    SET_FINISHED_JOB,
    SET_MESSAGES
} from './Actions';
import { SET_CHAT_MESSAGES } from './actions/Api';

export default (state = initialState, action) => {
    //console.log('Reducer switch: ', action.type, action.payload, state);
    switch (action.type) {
        case SET_CHAT_MESSAGES:
            return { ...state, job_messages: action.payload };
        case SET_MESSAGES:
            return { ...state, global_messages: action.payload };
        case SET_FINISHED_JOB:
            return { ...state, finished_job: action.payload };
        case SEND_OTP:
            return { ...state, otp: action.payload };
        case SET_BID:
            return { ...state, winning_bid: action.payload };
        case SET_BIDS:
            return { ...state, bids: action.payload };
        case CREATE_ACCOUNT:
            return { ...state };
        case SET_ACTIVE_JOB:
            return { ...state, active_job: action.payload };
        case SET_FIREBASE_TOKEN:
            return { ...state, firebase_token: action.payload };
        case SET_TOKEN:
            return { ...state, token: action.payload };
        case SET_PROFILE:
            return { ...state, profile: action.payload };
        case GET_CARLIST:
            return { ...state, cars_list: action.payload };
        case SET_JOB:
            return { ...state, job: action.payload };
        case GET_JOB:
            return { ...state };
        case GET_FIREBASE_TOKEN:
            return {...state, token: action.payload};
        case SET_ACTIVE_SCREEN:
            return { ...state, screen: action.payload };
        case SET_PHONE:
            return { ...state, phonenumber: action.payload };
        default:
            return state;
    }
};
